import { callDecimal } from "../utils";

export function clearLicenseCache() {
  return callDecimal<unknown>(`/api/v1/clear_cache`, {
    method: "POST",
  });
}
